import {
  ModalContent,
  Title as StyledTitle,
  CloseModalIcon
} from '../view-product/product-details-modal.styles';
import {
  Modal,
  Box,
  Button,
  IconButton,
  TextField,
  InputAdornment,
  CircularProgress,
  Divider,
  Snackbar,
  Alert,
  Typography
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { styled } from '@mui/material/styles';

export { ModalContent, CloseModalIcon, InputAdornment };

export const StyledModal = styled(Modal)({
  width: '400px',
  height: '370px',
  marginTop: '300px',
  marginLeft: 'calc(51.5% - 1140px / 2)'
});

export const CloseModalButton = styled(IconButton)({
  marginLeft: '108%',
  marginTop: '2%',
  marginBottom: '-30px',
  '&:hover': {
    background: 'white'
  }
});

export const SectionColumn = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  height: '85%',
  marginTop: '30px'
});

export const ImageContainer = styled(Box)({
  marginTop: '-150px',
  marginLeft: '4px',
  width: '160px',
  height: '160px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative'
});

export const ProductImage = styled('img')({
  maxWidth: '160px',
  maxHeight: '160px',
  display: 'block',
  margin: 'auto'
});

export const Spinner = styled(CircularProgress)({
  color: '#5F65F6'
});

export const Title = styled(StyledTitle)({
  fontSize: '20px',
  fontWeight: 600
});

export const ImageUrlTextbox = styled(TextField)({
  marginTop: '15px',
  marginBottom: '-5px',
  '& .MuiOutlinedInput-root': {
    width: '328px',
    height: '40px',
    borderRadius: '4px',
    marginTop: '15px',
    '&.Mui-focused fieldset': {
      borderColor: '#5F65F6'
    },
    '&:hover fieldset': {
      borderColor: '#5F65F6'
    }
  },
  '& .MuiInputLabel-root': {
    position: 'absolute',
    left: '-12px',
    '&.Mui-focused': {
      color: 'rgba(0,0,0,0.6)'
    },
    '&.Mui-error': {
      color: 'rgba(0,0,0,0.6)'
    }
  }
});

export const SubmitUrlButton = styled(Button)({
  height: '36px',
  width: '63px',
  color: '#3F51B5',
  fontFamily: 'Open Sans',
  paddingLeft: '35px',
  fontStyle: 'normal',
  fontWeight: '600',
  fontSize: '14px',
  lineHeight: '24px',
  textTransform: 'none',
  '&:hover': {
    background: 'white'
  },
  '&.Mui-disabled': {
    color: '#3F51B5',
    opacity: 0.5
  }
});

export const EditImageButton = styled(IconButton)({
  color: 'rgba(0, 0, 0, 0.5)',
  background: 'white',
  borderRadius: '50%',
  position: 'absolute',
  border: '1px solid rgba(0, 0, 0, 0.5)',
  '&:hover': {
    background: 'white'
  }
});

export const EditImageIcon = EditIcon;

export const UploadImageButton = styled('label')({
  backgroundColor: '#5F65F6',
  fontFamily: 'Open Sans',
  color: 'white',
  textAlign: 'center',
  width: '328px',
  height: '38px',
  paddingTop: '5px',
  marginTop: '18px',
  marginBottom: '35px',
  borderRadius: '10px',
  textTransform: 'none',
  fontWeight: 600,
  letterSpacing: '0.4px',
  boxShadow:
    '0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px rgba(0, 0, 0, 0.14), 0px 1px 5px rgba(0, 0, 0, 0.12)',
  lineHeight: '34px',
  cursor: 'pointer'
});

export const ImageErrorSnackbar = styled(Snackbar)({
  width: '100%',
  height: '68px',
  borderRadius: '4px',
  position: 'absolute',
  marginRight: '10px',
  boxSizing: 'border-box',
  '&.MuiSnackbar-anchorOriginTopCenter': {
    padding: '0 12px 20px 12px'
  }
});

export { Alert };

export const ModalDivider = styled(Divider)({
  color: '#B6B6B6',
  width: '328px'
});

export const RemoveImageIcon = DeleteIcon;

export const RemoveImageButton = styled(Button)({
  marginTop: '20px',
  color: '#3F51B5',
  textAlign: 'center',
  textTransform: 'none',
  fontFamily: 'Open Sans',
  fontSize: '14px',
  fontWeight: '600',
  lineHeight: '24px',
  '&:hover': {
    background: 'white'
  },
  '&.Mui-disabled': {
    color: '#3F51B5',
    opacity: 0.5
  }
});

export const RemoveImageHelperText = styled(Typography)({
  color: '#212121',
  fontFamily: 'Open Sans',
  fontSize: '12px',
  fontStyle: 'normal',
  fontWeight: '400',
  lineHeight: '20px',
  textAlign: 'center',
  marginTop: '16px',
  width: '328px'
});

export const BackdropStyles = {
  style: {
    background: 'transparent'
  }
};
